/** @jsxImportSource @emotion/react */

import React from "react";
import title from "./images/2022title.jpeg";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

const A4PageWithNoSpace = styled.div`
  width: 1000px;
  height: 1410px;
  page-break-before: always;
  page-break-after: always;
  display: flex;
  flex-direction: column;
`;

export default function YearInReviewTitle() {
  return (
    <A4PageWithNoSpace>
      <img
        src={title}
        css={css`
          width: 100%;
          height: 100%;
        `}
      />
    </A4PageWithNoSpace>
  );
}
